import { render, staticRenderFns } from "./DocumentList.vue?vue&type=template&id=5a38f0a4&scoped=true&"
import script from "./DocumentList.vue?vue&type=script&lang=ts&"
export * from "./DocumentList.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentList.vue?vue&type=style&index=0&id=5a38f0a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a38f0a4",
  null
  
)

export default component.exports